import { A as X } from "./abort.js";
import { F as m } from "./requestHelpers.js";
import { w as v } from "./withResolvers.js";
async function A(a, e) {
  var u;
  const { resolve: l, reject: o, promise: R } = v(), d = (e == null ? void 0 : e.method) ?? "GET", b = new Headers(e == null ? void 0 : e.headers), s = new XMLHttpRequest();
  s.upload.onprogress = H, s.onload = h, s.onabort = () => o(new X("XHR abort")), s.onerror = () => o(new m(a, d, "XHR error")), s.ontimeout = () => o(new m(a, d, "XHR timeout error")), (u = e == null ? void 0 : e.signal) == null || u.addEventListener("abort", () => s.abort()), s.open(d, a, !0);
  for (const [t, r] of b.entries())
    s.setRequestHeader(t, r);
  if ((e == null ? void 0 : e.body) instanceof ReadableStream)
    throw new Error("ReadableStream is not supported in requesterUpload");
  return s.send(e == null ? void 0 : e.body), R;
  function H(t) {
    var r;
    (r = e == null ? void 0 : e.onProgress) == null || r.call(e, t.loaded / t.total * 100);
  }
  function h() {
    const t = new Response(s.status === 204 ? null : s.response, {
      status: s.status,
      statusText: s.statusText,
      headers: w()
    });
    l(t);
  }
  function w() {
    return s.getAllResponseHeaders().trim().split(/[\r\n]+/).map((n) => {
      const p = n.indexOf(": "), q = n.substring(0, p), E = n.substring(p + 2);
      return [q, E];
    });
  }
}
export {
  A as d
};
//# sourceMappingURL=requesterUpload.js.map
